export default __webpack_public_path__ + "svg/CompaniesLogos/logo_improven.svg?adae490d";